<template>
  <div class="picture-reference">
    <a v-if="href" :href="href">
      {{ type }}: {{ src }}
    </a>
    <span v-else>
      {{ type }}: {{ src }}
    </span>
  </div>
</template>

<script>
export default {
    name: 'PictureReference',
    props: {
        src: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'Foto',
        },
        href: {
            type: String,
            default: '',
        }
    },
};
</script>

<style scoped>
.picture-reference {
  position: absolute;
  z-index: 10;
  right: calc(50% - 629px);
  bottom: 0;
  padding: 2px 10px;
  font-size: 12px;
  color: #4e4e4e;
  background: rgba(255,255,255,0.8);
}

.picture-reference a {
  text-decoration: none;
  color: #4e4e4e;
}

.picture-reference a:hover {
  text-decoration: underline;
}

@media (max-width: 1300px) {
  .picture-reference {
    right: 20px;
  }
}
</style>
